import type { Column } from "@shared/types/data-table"
import type { NetworkToken } from "@shared/types/network-token.types"
import type { ColumnManagementConfig } from "@shared/lib/tables/utils/column-management"
import {
  createStatusColumn,
  createTextColumn,
  createDateColumn,
} from "./column-factories"

export const NETWORK_TOKEN_COLUMNS: Record<string, Column<NetworkToken>> = {
  status: createStatusColumn<NetworkToken>("network-token"),
  tokenBin: createTextColumn<NetworkToken>(
    "tokenBin",
    "Token BIN",
    100,
    "font-mono text-muted-foreground group-hover:text-foreground"
  ),
  tokenLast4: createTextColumn<NetworkToken>(
    "tokenLast4",
    "Token Last 4",
    110,
    "font-mono text-muted-foreground group-hover:text-foreground"
  ),
  tokenExpiration: createTextColumn<NetworkToken>(
    "tokenExpiration",
    "Token Expiration",
    130,
    "text-muted-foreground group-hover:text-foreground"
  ),
  cardBin: createTextColumn<NetworkToken>(
    "cardBin",
    "Card BIN",
    100,
    "font-mono text-muted-foreground group-hover:text-foreground"
  ),
  cardNetwork: createTextColumn<NetworkToken>(
    "cardNetwork",
    "Card Network",
    120,
    "text-muted-foreground group-hover:text-foreground"
  ),
  merchantName: createTextColumn<NetworkToken>(
    "merchantName",
    "Merchant",
    140,
    "text-muted-foreground group-hover:text-foreground"
  ),
  tokenProvisioned: createDateColumn<NetworkToken>("tokenProvisioned", "Token Provisioned", 170),
}

export const NETWORK_TOKEN_STATUS_CONFIG = {
  all: ["status", "tokenBin", "tokenLast4", "tokenExpiration", "cardBin", "cardNetwork", "merchantName", "tokenProvisioned"],
} as const

export const getNetworkTokenColumns = (status: string = 'all'): Column<NetworkToken>[] => {
  const keys = NETWORK_TOKEN_STATUS_CONFIG[status as keyof typeof NETWORK_TOKEN_STATUS_CONFIG] || NETWORK_TOKEN_STATUS_CONFIG.all
  return keys.map(key => NETWORK_TOKEN_COLUMNS[key]).filter(Boolean)
}

export const getNetworkTokenColumnConfig = (status: string = 'all'): ColumnManagementConfig[] => {
  const visibleKeys: Set<string> = new Set(NETWORK_TOKEN_STATUS_CONFIG[status as keyof typeof NETWORK_TOKEN_STATUS_CONFIG] || NETWORK_TOKEN_STATUS_CONFIG.all)
  return Object.entries(NETWORK_TOKEN_COLUMNS).map(([key, col], index) => ({
    id: col.key,
    label: typeof col.header === 'string' ? col.header : col.key,
    visible: visibleKeys.has(key),
    required: ["status", "tokenBin"].includes(key),
    order: index,
  }))
}
